import { render } from "./RequestResetPasswordByPhone.vue?vue&type=template&id=439d0db8&scoped=true"
import script from "./RequestResetPasswordByPhone.vue?vue&type=script&lang=js"
export * from "./RequestResetPasswordByPhone.vue?vue&type=script&lang=js"

import "./RequestResetPasswordByPhone.vue?vue&type=style&index=0&id=439d0db8&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-439d0db8"]])

export default __exports__